import React from "react";
import MovieCard from "./MovieCard";

function MovieList({ movies, toggleFavourite, favourites, searchQuery }) {

  if (searchQuery === "") {
    return <p>Please enter a movie name to search.</p>;
  }

  if (movies.length === 0) {
    return <p>No movies found.</p>;
  }

  return (
    <div className="movie-list">

      {movies.map((movie) => (
        <MovieCard
          key={movie.id}
          movie={movie}
          toggleFavourite={toggleFavourite}
          isFavourite={favourites.some(fav => fav.id === movie.id)}
        />
      ))}

    </div>
  );
}

export default MovieList;